/**
 * Created by saha.moinak on 02/07/2020.
 */
import reducerRegistry from '@comeon/reducer-registry';

export const SHOW_WEB_PUSH_PERMISSION_MODAL = '@komigen/mobile-frontend/webpush/SHOW_WEB_PUSH_PERMISSION_MODAL';
export const WEB_PUSH_USER_SUBSCRIBED_STATUS = '@komigen/mobile-frontend/webpush/WEB_PUSH_USER_SUBSCRIBED_STATUS';
export const WEB_PUSH_USER_LOGOUT = '@komigen/mobile-frontend/webpush/WEB_PUSH_USER_LOGOUT';

const REDUCER_NAME = 'webpush';

const isWebPushPromptVisibleSelector = state => state[REDUCER_NAME].isWebPushPromptVisible;
const selectorEmarsysUserSubscribed = state => state[REDUCER_NAME].isUserSubscribedEmarsys;
const selectedtextKeys = state => state[REDUCER_NAME].webPushTextKeySet;

const showWebPushPrompt = (show, webPushTextKeySet) => ({
	type: SHOW_WEB_PUSH_PERMISSION_MODAL,
	payload: { show, webPushTextKeySet: webPushTextKeySet || null }
});

const linkEmarsysContact = (fieldId, username) => {
	try {
		if (window.WebEmarsysSdk) {
			window.WebEmarsysSdk.login({
				fieldId: parseInt(fieldId, 10),
				fieldValue: username
			});
		}
	} catch (err) {
		// Handle error?
	}
};

const logoutEmarsysContact = () => {
	try {
		if (window.WebEmarsysSdk) {
			window.WebEmarsysSdk.logout();
		}
	} catch (err) {
		// Handle error?
	}
};

const resetWebPush = () => ({
	type: WEB_PUSH_USER_LOGOUT
});

const checkIfUserIsSubscribedOnEmarsys = () => {
	return async dispatch => {
		if (window.WebEmarsysSdk && Object.hasOwn(window.WebEmarsysSdk, 'isSubscribed')) {
			const data = await window.WebEmarsysSdk.isSubscribed();
			if (data === true) {
				dispatch({
					type: WEB_PUSH_USER_SUBSCRIBED_STATUS,
					payload: true
				});
			}
		}
	};
};

const subscribeToWebPush = () => {
	if (window.WebEmarsysSdk) {
		window.WebEmarsysSdk.subscribe();
	}
};

const updateSubscribedStatus = status => ({
	type: WEB_PUSH_USER_SUBSCRIBED_STATUS,
	payload: status
});

function reducer(
	state = {
		isWebPushPromptVisible: false,
		isUserSubscribedEmarsys: false,
		isUserContactInfoAvailable: false,
		webPushTextKeySet: null // `successful-deposit`, `we-spin-success`, `withdraw-request`
	},
	action
) {
	switch (action.type) {
		case SHOW_WEB_PUSH_PERMISSION_MODAL:
			return {
				...state,
				isWebPushPromptVisible: action.payload.show,
				webPushTextKeySet: action.payload.webPushTextKeySet
			};

		case WEB_PUSH_USER_SUBSCRIBED_STATUS:
			return {
				...state,
				isUserSubscribedEmarsys: action.payload
			};

		case WEB_PUSH_USER_LOGOUT:
			return {
				...state,
				isWebPushPromptVisible: false,
				isUserSubscribedEmarsys: false,
				isUserContactInfoAvailable: false
			};

		default:
			return state;
	}
}

reducerRegistry.register(REDUCER_NAME, reducer);

export {
	showWebPushPrompt,
	isWebPushPromptVisibleSelector,
	linkEmarsysContact,
	logoutEmarsysContact,
	checkIfUserIsSubscribedOnEmarsys,
	selectorEmarsysUserSubscribed,
	resetWebPush,
	subscribeToWebPush,
	updateSubscribedStatus,
	selectedtextKeys
};

export default reducer;
